import React, { useEffect, useState } from "react";
import Shopsubbanner from "../../components/shopsubbanner";
import ProductGrid from "../../components/ProductGrid";

const Lollipop = ({ products, loading, error }) => {
  const [bannerImage, setBannerImage] = useState(
    "https://res.cloudinary.com/dtivafy25/image/upload/v1754306784/D_CLair_Lolipop_wdos4q.jpg" // Desktop
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    const updateBanner = () => {
      if (window.innerWidth <= 768) {
        // Mobile banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1754651194/05_z0enzz.jpg");
      } else {
        // Desktop banner
        setBannerImage("https://res.cloudinary.com/dtivafy25/image/upload/v1754306784/D_CLair_Lolipop_wdos4q.jpg");
      }
    };

    updateBanner(); // Run once on mount
    window.addEventListener("resize", updateBanner);

    return () => {
      window.removeEventListener("resize", updateBanner);
    };
  }, []);

  return (
    <>
      <Shopsubbanner image_url={bannerImage} />
      <ProductGrid category="Lollipop" products={products} loading={loading} error={error} />
    </>
  );
};

export default Lollipop;
